export default __webpack_public_path__ + "static/media/notify2.cdcf6f7b.mp3";